var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg162 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BEE4F8",
  d: "M6.882 7.396c1.12 0 2.174.285 3.094.785a9.24 9.24 0 0 0-3.26 6.297h-.532A6.18 6.18 0 0 0 1.2 17a6.483 6.483 0 0 1 5.682-9.604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.524 12.383a5.63 5.63 0 0 1 5.222 3.512l.084.22.248.698h-9.395l-2.405 8.536H18.02a3.25 3.25 0 0 1-3.258-3.237 3.246 3.246 0 0 1 3.073-3.233l.185-.005h1.783l.116-1.37c.243-2.883 2.675-5.12 5.605-5.12m-9.579-4.887a7.77 7.77 0 0 1 6.775 3.962 7.1 7.1 0 0 0-4.263 5.645l-.029.275h-.408c-2.627 0-4.755 2.12-4.755 4.734 0 1.169.426 2.239 1.131 3.065l.156.173H6.184a4.687 4.687 0 0 1-.214-9.371l.214-.005h1.907l.115-1.37a7.77 7.77 0 0 1 7.74-7.108m17.18 9.545c2.309 0 4.178 1.861 4.178 4.154 0 2.224-1.758 4.041-3.97 4.15l-.208.005h-.806l1.533-2.55H28.63l2.547-5.708.068.19 1.225-.19q.322-.05.655-.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M22.819 18.313 20.148 27.8h4.605l-2.58 11.513L31.2 24.3H26.32l2.67-5.987z"
}))));
export { Svg162 as ReactComponent };